// src/components/MenuBar/MenuBar.tsx

import React from "react";
import { Link, useNavigate } from "react-router-dom";
import api from "../../api/client";
import "./MenuBar.css";

const MenuBar: React.FC = () => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    try {
      await api.post("/logout");
      navigate("/");
    } catch (error) {
      console.error("Logout failed:", error);
    }
  };

  return (
    <nav className="menu-bar">
      <ul>
        <li>
          <Link to="/home">Home</Link>
        </li>

        <li>
          <Link to="/clients">Clients</Link>
        </li>

        <li>
          <Link to="/finance">Finance</Link>
        </li>

        <li>
          <button onClick={handleLogout}>Logout</button>
        </li>
      </ul>
    </nav>
  );
};

export default MenuBar;
